module.exports = __webpack_public_path__ + "img/air-sea-freight.d145fd9e.jpg";